export default function SectionAbout() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">关于黑料爆料</h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10">吃瓜群众最信赖的娱乐圈八卦与明星黑料资讯平台</p>

        <div className="bg-background-100 rounded-xl p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-[700px] mx-auto">
            黑料爆料吃瓜网诞生于吃瓜群众的真实需求——在这个信息爆炸的时代，娱乐圈八卦、明星黑料、社会热点层出不穷，
            但真正靠谱的吃瓜平台却少之又少。我们汇聚51吃瓜与17c黑料爆料两大热门渠道的精华内容，由专业编辑团队全天候筛选、
            核实、整理，为吃瓜群众呈现最真实、最及时、最全面的娱乐圈资讯。
          </p>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-[700px] mx-auto mt-4">
            我们坚持理性吃瓜的原则：不传谣、不造谣、不恶意炒作。每一条爆料都力求多方交叉验证，
            为吃瓜群众提供清晰的可信度标注。我们相信，吃瓜不仅是一种娱乐方式，更是对娱乐圈生态的大众监督。
            欢迎每一位热爱吃瓜的你，加入我们的瓜田大家庭。
          </p>
        </div>
      </div>
    </section>
  );
}